import React, { useEffect, useState } from 'react';
import TestimonialCard from '../../components/Testimonial/TestimonialCard ';

const TestimonialsMain = () => {
    const [testimonials, setTestimonials] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_BASE_URL}/api/testimonials/`)
            .then((res) => {
                if (!res.ok) throw new Error('Network response was not ok');
                return res.json();
            })
            .then((data) => {
                // Map API fields to expected fields
                const mapped = data.map((item, idx) => ({
                    id: item.id || idx,
                    imageUrl: item.image,
                    clientName: item.client_name,
                    clientTitle: item.client_title,
                    rating: item.rating,
                    testimonialText: item.testimonial_text,
                }));
                setTestimonials(mapped);
                setLoading(false);
            })
            .catch((err) => {
                setError(err.message);
                setLoading(false);
            });
    }, []);

    if (loading) return <div>Loading...</div>;
    if (error) return <div>Error: {error}</div>;

    return (
        <section className="testimonials-page">
            <div className="container">
                <div className="row">
                    {testimonials.map((testimonial, index) => (
                        <TestimonialCard
                            key={testimonial.id || index}
                            imageUrl={testimonial.imageUrl}
                            clientName={testimonial.clientName}
                            clientTitle={testimonial.clientTitle}
                            rating={testimonial.rating}
                            testimonialText={testimonial.testimonialText}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default TestimonialsMain;
